import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../api/supabase';

export default function AgentList() {
  const navigate = useNavigate();
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    supabase.from('agents').select('*').order('tls_code').then(({ data }) => {
      setAgents(data || []);
      setLoading(false);
    });
  }, []);

  const filtered = agents.filter(a =>
    !search ||
    a.tls_code?.toLowerCase().includes(search.toLowerCase()) ||
    a.full_name?.toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Agents</div>
          <div className="page-subtitle">Travel agents by TLS code</div>
        </div>
        <button className="btn btn-primary" onClick={() => navigate('/agents/new')}>+ New Agent</button>
      </div>

      <div className="card" style={{ padding: '12px 16px', marginBottom: 0, borderRadius: '10px 10px 0 0' }}>
        <input className="form-input" style={{ maxWidth: 320 }} placeholder="Search TLS code or name…" value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      <div className="card" style={{ padding: 0, borderRadius: '0 0 10px 10px', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: 'var(--bg)', borderBottom: '2px solid var(--border)' }}>
              <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, fontSize: 12, color: 'var(--text-muted)', textTransform: 'uppercase' }}>TLS Code</th>
              <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, fontSize: 12, color: 'var(--text-muted)', textTransform: 'uppercase' }}>Name</th>
              <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, fontSize: 12, color: 'var(--text-muted)', textTransform: 'uppercase' }}>Phone</th>
              <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, fontSize: 12, color: 'var(--text-muted)', textTransform: 'uppercase' }}>Email</th>
              <th style={{ padding: '10px 16px', textAlign: 'center', fontWeight: 600, fontSize: 12, color: 'var(--text-muted)', textTransform: 'uppercase' }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(a => (
              <tr key={a.id}
                onClick={() => navigate(`/agents/${a.id}`)}
                style={{ borderBottom: '1px solid var(--border)', cursor: 'pointer' }}
                onMouseEnter={e => e.currentTarget.style.background = 'var(--bg)'}
                onMouseLeave={e => e.currentTarget.style.background = ''}
              >
                <td style={{ padding: '10px 16px', fontWeight: 700, fontFamily: 'monospace', color: 'var(--primary)' }}>{a.tls_code}</td>
                <td style={{ padding: '10px 16px', fontWeight: 500 }}>{a.full_name}</td>
                <td style={{ padding: '10px 16px', color: 'var(--text-muted)' }}>{a.mobile || a.phone || '—'}</td>
                <td style={{ padding: '10px 16px', color: 'var(--text-muted)' }}>{a.email || '—'}</td>
                <td style={{ padding: '10px 16px', textAlign: 'center' }}>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 99, background: a.is_active ? '#dcfce7' : '#fee2e2', color: a.is_active ? '#16a34a' : '#dc2626' }}>
                    {a.is_active ? 'Active' : 'Inactive'}
                  </span>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={5} style={{ padding: 40, textAlign: 'center', color: 'var(--text-muted)' }}>No agents found</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
